import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../utils/apiClient";
import IngredientListGrouped from "../components/IngredientListGrouped";
import ShoppingList from "../components/ShoppingList";
import BackButton from "../components/BackButton";

export default function WeeklyIngredientsPage() {
  const { startDate } = useParams(); 
  const [recipes, setRecipes] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    setIsLoading(true);
    apiClient
      .get(`/calendar/ingredients/week/${startDate}`,
      { headers: { "X-Client-Version": "2" } })
      .then((res) => {
        // old‐style: res.data is an array of recipes
        const recipesPayload = Array.isArray(res.data) ? res.data : [];
          
        // new‐style: only if the server sent it
        const shoppingPayload = Array.isArray(res.data.ingredientList) ? res.data.ingredientList : [];  

        setRecipes(recipesPayload);
        setIngredientList(shoppingPayload);
      }).finally(() => {
        setIsLoading(false);
      })
  }, [startDate]);

  const nothingToShow =
  !isLoading && recipes.length === 0 && ingredientList.length === 0;


  return (
    <div className="max-w-3xl mx-auto px-4 mt-10 space-y-6">
      <BackButton />
      <h1 className="text-2xl font-bold mb-4">Weekly Ingredient List</h1>

      {isLoading ? (
        <p className="text-gray-500">Loading ingredients…</p>
      ) : nothingToShow ? (
        <p className="text-gray-600">No ingredients found for this week.</p>
      ) : (
        <>
          {ingredientList ? (
            <ShoppingList ingredientList={ingredientList} weekStart={startDate} />
          ) : 
          <IngredientListGrouped recipes={recipes} />
          }
        </>
      )}
    </div>
  );
}
